import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=51fad8b7&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=51fad8b7&lang=scss&scoped=true&"
import style1 from "./MenuItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fad8b7",
  null
  
)

export default component.exports